import { combineReducers } from "redux";
// import counterReducer from 'features/example/counterSlice';
// import startUpReducer from 'features/startup/StartUpSlice';
import loginReducer from "./login/LoginSlice";
import CustomerServiceReducer from "./CustomerService/CustomerServiceSlice";
// import formDataReducer from 'features/formData/formDataSlice';
import customerReducer from "./CustomerProfile/CustomerInfoSlice";
export default combineReducers({
  /**Add more reducers here*/
  // counter: counterReducer,
  // startUp: startUpReducer,
  login: loginReducer,
  customerInfo: customerReducer,
  CustomerService: CustomerServiceReducer,
  // formData: formDataReducer,
});
